export default __webpack_public_path__ + "CircularCustCapNum-BlackItalic.eb3b4a3e6bfd81920c2b178a7703e6f2.ttf";